import QRCode from "qrcode";
import { createResource } from "solid-js";

/**
 * Render a QR for `value` as inline SVG. The SVG sits on a white quiet zone
 * (see `.totp-qr` CSS) so scanners read it regardless of theme. `qrcode`
 * generates the SVG markup async.
 */
export function QrCode(props: { value: string; size?: number }) {
  const [svg] = createResource(
    () => props.value,
    (v) => QRCode.toString(v, { type: "svg", margin: 1, width: props.size ?? 192 }),
  );
  // innerHTML is locally-generated QR SVG (no user HTML) — safe.
  return <div class="totp-qr" innerHTML={svg() ?? ""} />;
}
